export const formatDate = (dateString) => {
  const d = new Date(dateString);

  const formattedDateString = Intl.DateTimeFormat('Ru-ru', {
    dateStyle: 'short',
    timeStyle: 'medium',
  }).format(d);

  const [date, time] = formattedDateString.split(',');

  return (
    <span>
      <span style={{ fontSize: '16px', fontWeight: 500 }}>{time}</span> <br />
      <span
        style={{
          fontSize: '14px',
          fontWeight: 400,
          color: '#637083',
        }}
      >
        {date}
      </span>
    </span>
  );
};
